import { getDurationFrom } from './timeHelper'

export const DEFAULT_STALE_DETECTION_WARNING_MINUTES = 5
export const DEFAULT_STALE_DETECTION_WARNING_COLOR = '#d93025'

export type StaleDetectionWarningConfigKey =
  | 'stale_detection_warning_enabled'
  | 'stale_detection_warning_minutes'
  | 'stale_detection_warning_color'

export type StaleDetectionWarningConfig = Pick<IGroup, StaleDetectionWarningConfigKey>

const HEX_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/

export const isValidStaleDetectionWarningColor = (
  color?: string | null,
): color is string => typeof color === 'string' && HEX_COLOR_PATTERN.test(color)

export const getStaleDetectionWarningMinutes = (
  config?: StaleDetectionWarningConfig | null,
): number => {
  const minutes = config?.stale_detection_warning_minutes

  if (typeof minutes === 'number' && Number.isFinite(minutes) && minutes > 0) {
    return minutes
  }

  return DEFAULT_STALE_DETECTION_WARNING_MINUTES
}

export const getStaleDetectionWarningColor = (
  config?: StaleDetectionWarningConfig | null,
): string => {
  const color = config?.stale_detection_warning_color

  if (isValidStaleDetectionWarningColor(color)) {
    return color
  }

  return DEFAULT_STALE_DETECTION_WARNING_COLOR
}

export const getStaleDetectionWarningMessage = (
  config?: StaleDetectionWarningConfig | null,
): string => `${getStaleDetectionWarningMinutes(config)}分以上検知されていません`

export const shouldShowStaleDetectionWarning = (
  detectedAt?: string | Date | number | null,
  config?: StaleDetectionWarningConfig | null,
): boolean => {
  if (!config?.stale_detection_warning_enabled || !detectedAt) {
    return false
  }

  return getDurationFrom(detectedAt).asMinutes() >= getStaleDetectionWarningMinutes(config)
}
